/* eslint-disable @atlaskit/editor/no-re-export */
export { DataSourceProvider } from '../data-source-provider';